class CollectionFilters extends HTMLElement {
  constructor() {
    super();
    this.collection = this.dataset.collection;
    this.productGrid = document.getElementById(`product-grid-container-${this.collection}`);
    this.dropdowns = this.querySelectorAll(".filter-dropdown");
    this.tags = this.querySelector(".tag-container");
    this.filters = this.querySelector(`#filter-container-${this.collection}`);
    this.emptyCollection = document.getElementById(`empty-collection-${this.collection}`);
    this.removeFiltersLink = this.emptyCollection.querySelector(".clear-filters");
    this.removeFiltersLink.addEventListener("click", this.clearFilters.bind(this));
    this.sort = this.querySelector(".collection-sort");
    this.sort.addEventListener("change", this.updateSort.bind(this));
    if (this.querySelectorAll(".filter-button")) {
      Array.from(this.querySelectorAll(".filter-button")).forEach(
        (button) => button.addEventListener("click", this.showDropdown.bind(this))
      );
    }
    if (this.tags.childNodes.length > 0) {
      this.initialiseTags();
    }
    if (this.querySelectorAll("input[type='number']")) {
      Array.from(this.querySelectorAll("input[type='number']")).forEach(
        (numberFilter) => numberFilter.addEventListener("change", this.updateNumberFilter.bind(this))
      );
    }
    if (this.querySelectorAll("input[type='checkbox']")) {
      Array.from(this.querySelectorAll("input[type='checkbox']")).forEach(
        (checkFilter) => checkFilter.addEventListener("change", this.updateCheckFilter.bind(this))
      );
    }
    this.setParams();
  }

  initialiseTags() {
    Array.from(this.querySelectorAll(".tag.is-delete")).forEach(
      (tag) => tag.addEventListener("click", this.deleteTagButton.bind(this))
    );
    this.removeFiltersTag = this.querySelector(".remove-filters-tag");
    this.removeFiltersTag.addEventListener("click", this.clearFilters.bind(this));
  }

  // Move to global
  setParams() {
    Shopify.queryParams = {};
    if (location.search.length) {
      let params = location.search.split('&');
      for (let i = 0; i < params.length; i++) {
        let keyValue = params[i].split('=');
        if (keyValue.length) {
          Shopify.queryParams[decodeURIComponent(keyValue[0])] = decodeURIComponent(keyValue[1]);
        }
      }
    }
  }

  clearFilters(event) {
    // Clear filter values
    event.preventDefault();
    Array.from(this.querySelectorAll("input[type='number']")).forEach(
      (numberFilter) => numberFilter.value = ''
    );
    Array.from(this.querySelectorAll("input[type='checkbox']")).forEach(
      (checkFilter) => checkFilter.checked = false
    );
    if (Shopify.queryParams.sort_by) {
      Shopify.queryParams = {sort_by: Shopify.queryParams.sort_by};
      this.updatePage(true, false);
    } else {
      Shopify.queryParams = {};
      this.updatePage(true, true);
    }
  }

  updatePage(clearFilters, clearSort) {
    Array.from(document.querySelectorAll(".card-image")).forEach(
      (cardImage) => cardImage.classList.add("blur-image")
    );
    let url, originalQuery, query;
    // Clear filters
    if (clearFilters && clearSort) {
      url = window.location.origin + window.location.pathname;
    // Update filters
    } else {
      originalQuery = new URLSearchParams(Shopify.queryParams).toString();
      query = originalQuery.replace(/%2C/g, ",");
      url = `${window.location.pathname}?${query}`;
    }
    fetch(url)
      .then((response) => {
        return response.text();
      })
      .then((html) => {
        const results = new DOMParser().parseFromString(html, 'text/html').getElementById(`product-grid-container-${this.collection}`);
        const updatedCollection = results.innerHTML;
        this.productGrid.innerHTML = updatedCollection;
        if (results.childElementCount == 0) {
          this.emptyCollection.classList.remove("is-hidden");
        } else {
          this.emptyCollection.classList.add("is-hidden");
        }
        if (clearFilters) {
          let resetFilters = new DOMParser().parseFromString(html, 'text/html').getElementById(`filter-container-${this.collection}`);
          this.filters = resetFilters;
          this.tags.replaceChildren(this.tags.firstElementChild);
          history.pushState({}, '', url);
        } else {
          history.pushState({ query }, '', `${window.location.pathname}${query && '?'.concat(query)}`);
        }
        Array.from(document.querySelectorAll(".card-image")).forEach(
          (cardImage) => cardImage.classList.remove("blur-image")
        );
        Array.from(this.dropdowns).forEach(function (dropdown) {
          dropdown.classList.remove("is-active");
        })
        // if (this.tags.childElementCount == 1) {
        //   this.tags.classList.add("is-hidden");
        // } else {
        //   this.tags.classList.remove("is-hidden");
        // }
      })
      .catch((error) => {
        // Show error
        console.log(error);
      });
  }

  updateSort() {
    Shopify.queryParams.sort_by = this.sort.value;
    this.updatePage(false, false);
  }

  showDropdown(event) {
    Array.from(this.dropdowns).forEach(function (dropdown) {
      if (dropdown.dataset.target == event.target.closest(".filter-button").id) {
        dropdown.classList.contains("is-active")
          ? dropdown.classList.remove("is-active")
          : dropdown.classList.add("is-active");
      } else {
        dropdown.classList.remove("is-active");
      }
    })
  }

  addTag(id, name, value, label) {
    if (id === 'Price-GTE') {
      label = "Greater than $" + value;
    } else if (id === 'Price-LTE') {
      label = "Less than $" + value;
    }
    this.tags.innerHTML +=
      `<div class="control" id="tag-${id}">
        <div class="tags has-addons">
          <a class="tag tag-label bg-background-2" data-target="tag-${id}">${label}</a>
          <a class="tag filter-tag is-delete bg-background-2" data-filter="${name}" data-filter-id="${id}" data-value="${value}" data-target="tag-${id}"></a>
        </div>
      </div>`;
    this.initialiseTags();
  }

  modifyPriceTag(id, value) {
    let label;
    if (id === 'Price-GTE') {
      label = "Greater than $" + value;
    } else if (id === 'Price-LTE') {
      label = "Less than $" + value;
    }
    this.tags.querySelector(`.tag-label[data-target='tag-${id}']`).textContent = label;
  }
  
  removeFilterValue(name, value) {
    const existingParams = Shopify.queryParams[name];
    const paramWithComma = value + ",";
    let updatedParams = existingParams.replace(paramWithComma, "");
    // If param doesn't have trailing comma
    if (existingParams === updatedParams) {
      updatedParams = existingParams.replace(value, "");
      if (updatedParams.slice(-1) === ",") {
        updatedParams = updatedParams.slice(0, updatedParams.length - 1);
      }
    }
    updatedParams
      ? Shopify.queryParams[name] = updatedParams
      : delete Shopify.queryParams[name];
  }

  deleteTag(controlId, filterId, filterName, filterValue) {
    this.removeFilterValue(filterName, filterValue);
    this.updatePage(false, false);

    // Reset input
    filterId.includes("Price")
      ? this.querySelector(`input[id='${filterId}']`).value = ''
      : this.querySelector(`input[id='${filterId}']`).checked = false;

    // Remove tag
    this.tags.querySelector(`div[id='${controlId}']`).remove();
  }

  deleteTagButton(event) {
    const controlId = event.target.dataset.target, filterId = event.target.dataset.filterId, filterName = event.target.dataset.filter, filterValue = event.target.dataset.value;
    this.deleteTag(controlId, filterId, filterName, filterValue);
  }

  updateNumberFilter(event) {
    const filterId = event.target.id, filterName = event.target.name, filterValue = event.target.value;
    const controlId = `tag-${filterId}`;
    const existingParam = Shopify.queryParams[filterName];

    if (filterValue) {
      existingParam
        ? this.modifyPriceTag(filterId, filterValue)
        : this.addTag(filterId, filterName, filterValue, filterId);
      Shopify.queryParams[filterName] = filterValue;
    } else {
      this.deleteTag(controlId, filterId, filterName, filterValue);
      delete Shopify.queryParams[filterName];
    }
    this.updatePage(false, false);
  }
  
  updateCheckFilter(event) {
    const filterId = event.target.id, filterName = event.target.name, filterValue = event.target.value;
    const checked = event.target.checked;
    const parent = event.target.parentNode;
    const existingParams = Shopify.queryParams[filterName];
    
    if (existingParams) {
      const existingParamsArr = Shopify.queryParams[filterName].split(",");
      // Remove param, filter unchecked
      if (existingParamsArr.includes(filterValue) && !checked) {
        this.removeFilterValue(filterName, filterValue);
        this.tags.querySelector(`div[id='tag-${filterId}']`).remove();
      // Add param, not already included
      } else if (!existingParamsArr.includes(filterValue)) {
        Shopify.queryParams[filterName] = existingParams + "," + filterValue;
        this.addTag(filterId, filterName, filterValue, parent.textContent.trim());
      }
    // No existing params, add new param
    } else {
      Shopify.queryParams[filterName] = filterValue;
      this.addTag(filterId, filterName, filterValue, parent.textContent.trim());
    }
    this.updatePage(false, false);
  }
}

customElements.define('collection-filters', CollectionFilters);

window.addEventListener('DOMContentLoaded', function() {
  // Close filter dropdown if user clicks outside filter button or dropdown
  document.addEventListener(
    "click",
    (event) => {
      // TODO Check selectors, should be everything outside filter dropdown and filter button
      if (
        !event.target.matches(".filter-button") && 
        !event.target.matches(".filter-item") && 
        !event.target.matches("input") && 
        !event.target.matches(".filter-checkbox-label") && 
        !event.target.matches(".filter-dropdown")
      ) {
        $(".filter-dropdown").removeClass("is-active");
      }
    },
    false
  )
});